<template>
  <div class="container mt-5">
    <h2 class="text-center mb-4">Create New Page</h2>
    <form @submit.prevent="handleSubmit">
      <!-- Title -->
      <div class="form-group mb-3">
        <label for="title">Title</label>
        <input
          type="text"
          v-model="formData.title"
          class="form-control"
          id="title"
          placeholder="Enter page title"
          required
        />
      </div>

      <!-- Path -->
      <div class="form-group mb-3">
        <label for="path">Path</label>
        <input
          type="text"
          v-model="formData.path"
          class="form-control"
          id="path"
          placeholder="Enter URL path (optional)"
        />
      </div>

      <!-- Slug -->
      <div class="form-group mb-3">
        <label for="slug">Slug</label>
        <input
          type="text"
          v-model="formData.slug"
          class="form-control"
          id="slug"
          placeholder="Enter slug"
          required
        />
      </div>

      <!-- HTML Content -->
      <div class="form-group mb-3">
        <label for="html_content">HTML Content</label>
        <Codemirror
          v-model:value="formData.html_content"
          :options="cmOptions"
          placeholder="Enter HTML content here..."
          :height="400"
          @change="onHtmlContentChange"
        />
      </div>

      <!-- Status -->
      <div class="form-group mb-3">
        <label for="status">Status</label>
        <select v-model="formData.status" class="form-control" id="status">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <!-- Submit Button -->
      <button type="submit" class="btn btn-primary">Create Page</button>
    </form>
  </div>
</template>

<script>
import Codemirror from "codemirror-editor-vue3";
import "codemirror/addon/display/placeholder.js";
import "codemirror/mode/javascript/javascript.js"; // Adjust to mode if you want HTML mode
import "codemirror/theme/dracula.css"; // Theme for the editor
import { ref } from "vue";

export default {
  components: { Codemirror },
  setup() {
    const formData = ref({
      title: "",
      path: "",
      slug: "",
      html_content: "",
      status: "active"
    });

    const cmOptions = {
      mode: "text/html", // Language mode for HTML
      theme: "dracula", // Theme
      lineNumbers: true,
      tabSize: 2,
    };

    const handleSubmit = () => {
      // Send formData to the API
      fetch("/dashboard/create-page/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData.value),
      })
        .then(response => response.json())
        .then(data => {
          alert("Page created successfully!");
          console.log(data); // Log created page data
        })
        .catch(error => {
          console.error("Error creating page:", error);
        });
    };

    return {
      formData,
      cmOptions,
      handleSubmit,
    };
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
}
</style>
